import * as React from 'react';
import { styled } from 'styled-components';
import { Tooltip } from '@progress/kendo-react-tooltip';
import InfoSvg from '../../images/infoBlue.svg';
import ParseContentWithBold from '../pages_v2/common/ParseTextWithBold';

const CustomTooltip = ({ data }: Props) => {
	const tooltipContent = () => <TooltipContentTemplate title={data.title} content={data.content} />;

	return (
		<Tooltip content={tooltipContent} anchorElement="target" showCallout={false}>
			<Icon src={InfoSvg} alt="info" title={data.title} />
		</Tooltip>
	);
};

export default CustomTooltip;

const TooltipContentTemplate = (data: ToolTipModel) => {
	return (
		<Container>
			<Title>{data.title}</Title>
			<Content>
				{data.content.map((content: string) => (
					<Paragraph key={content}>{ParseContentWithBold(content)}</Paragraph>
				))}
			</Content>
		</Container>
	);
};

export interface ToolTipModel {
	title: string;
	content: string[];
}

type Props = {
	data: ToolTipModel;
};

const Icon = styled.img`
	width: 24px;
	height: 24px;
	padding: 5px;
	margin-right: -5px;
`;

const Container = styled.div`
	background: #1f2937;
	padding: 16px 12px;
	border-radius: 14px;
`;

const Title = styled.p`
	font-size: 12px;
	font-weight: 600;
	line-height: 16px;
	letter-spacing: 0.5px;
	margin-bottom: 16px;
`;

const Content = styled.div`
	margin-top: 6px;
`;

const BoldText = styled.span`
	font-weight: 600;
`;

const Paragraph = styled.p`
	font-size: 12px;
	line-height: 16px;
	letter-spacing: 0.4px;
	padding-bottom: 16px;

	&:last-child {
		padding-bottom: 0;
	}
`;

export const TooltipWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: baseline;
	height: 20px;
`;
